import * as Utils from "../utils/utils";

export function setChecklistCompletion(node) {
	// console.log("***** In " + arguments.callee.name);
	if (node.type === "checklist" && node.children) {
		// let childrenFiltered = node.children.filter(function (el) {
		// 	return Utils.isVisible(el);
		// });

		// node.children = childrenFiltered;

		let completionStateStr = "";
		let hideStatus = (node.hasOwnProperty("hideStatus") && node.hideStatus) ? true : false;

		let notStartedCount = 0;
		let completedCount = 0;
		let ignoreCompletionCount = 0;

		let progressCount = 0;
		let progressTotal = 0;

		for (let i=0; i<node.children.length; i++) {
			let list = node.children[i];
			if (list.completionState === "n" && (!list.ignoreCompletion && Utils.isVisible(list))) {
				notStartedCount++;
			} else if (list.completionState === "c" && (!list.ignoreCompletion && Utils.isVisible(list))) {
				completedCount++;
			}
			if (list.ignoreCompletion || !Utils.isVisible(list)) {
				ignoreCompletionCount++;
			}

			if (!list.ignoreCompletion && Utils.isVisible(list)) {
				progressCount = progressCount + list.progressCount;
				progressTotal = progressTotal + list.progressTotal;
			}
		}

		if (completedCount === (node.children.length-ignoreCompletionCount)) {
			completionStateStr = "c";
		} else if (notStartedCount === (node.children.length-ignoreCompletionCount)) {
			completionStateStr = "n";
		} else {
			completionStateStr = "i";
		}

		console.log("*** Checklist Status: " + progressCount + "; " + progressTotal);

		return {
			...node,
			completionState: completionStateStr,
			hideStatus: hideStatus,
			progressCount: progressCount,
			progressTotal: progressTotal
		  };  	
	} else {
		return node;
	}
}

export function setListCompletion(node) {
	// console.log("***** List Node: " + node);
	if (node.type === "list" && node.children) {
		// let childrenFiltered = node.children.filter(function (el) {
		// 	return Utils.isVisible(el);
		// });

		// node.children = childrenFiltered;

		let completionStateStr = "";
		let hideStatus = (node.hasOwnProperty("hideStatus") && node.hideStatus) ? true : false;

		let notStartedCount = 0;
		let completedCount = 0;
		let ignoreCompletionCount = 0;
		// let hideStatusCount = 0;

		let progressCount = 0;
		let progressTotal = 0;

		for (let i=0; i<node.children.length; i++) {
			let section = node.children[i];
			if (section.completionState === "n" && (!section.ignoreCompletion && Utils.isVisible(section))) {
				notStartedCount++;
			} else if (section.completionState === "c" && (!section.ignoreCompletion && Utils.isVisible(section))) {
				completedCount++;
			}
			// if (section.hideStatus) {
			// 	hideStatusCount++;
			// }
			if (section.ignoreCompletion || !Utils.isVisible(section)) {
				ignoreCompletionCount++;
			}

			if (!section.ignoreCompletion && Utils.isVisible(section)) {
				progressCount = progressCount + section.progressCount;
				progressTotal = progressTotal + section.progressTotal;
			}
		}

		if (completedCount === (node.children.length-ignoreCompletionCount)) {
			completionStateStr = "c";
		} else if (notStartedCount === (node.children.length-ignoreCompletionCount)) {
			completionStateStr = "n";
		} else {
			completionStateStr = "i";
		}

		console.log("*** List Status: " + progressCount + "; " + progressTotal);


		return {
			...node,
			completionState: completionStateStr,
			hideStatus: hideStatus,
			progressCount: progressCount,
			progressTotal: progressTotal
		  }; 	
	} else {
		return node;
	}
}

export function setSectionCompletion(node) {
	// console.log("***** Section Node: " + node);
	if (node.type === "section" && node.children) {
		// let childrenFiltered = node.children.filter(function (el) {
		// 	return Utils.isVisible(el);
		// });

		// node.children = childrenFiltered;

		let completionStateStr = "";
		let hideStatus = (node.hasOwnProperty("hideStatus") && node.hideStatus) ? true : false;

		let itemCount = 0;
		let ignoreCompletionCount = 0;

		for (let i=0; i<node.children.length; i++) {
			let item = node.children[i];
			if (item.checked && (!item.ignoreCompletion && Utils.isVisible(item))) {
				itemCount++;
			}
			if (item.ignoreCompletion || !Utils.isVisible(item)) {
				ignoreCompletionCount++;
			}
		}

		if (itemCount === (node.children.length-ignoreCompletionCount)) {
			completionStateStr = "c";
		} else if (itemCount === 0) {
			completionStateStr = "n";
		} else {
			completionStateStr = "i";
		}
		console.log("**** Section Status: " + node.name + "; " + itemCount + "; " + (node.children.length-ignoreCompletionCount));

		return {
			...node,
			completionState: completionStateStr,
			hideStatus: hideStatus,
			progressCount: itemCount,
			progressTotal: (node.children.length-ignoreCompletionCount)
		  };	
	} else {
		return node;
	}
}